import { enableES5 } from 'immer';
import 'nprogress/nprogress.css';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import ReactDOM from 'react-dom/client';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import 'react-perfect-scrollbar/dist/css/styles.css';
import 'react-quill/dist/quill.snow.css';
import { BrowserRouter } from 'react-router-dom';
import 'src/__mocks__';
import App from 'src/App';
import { AuthProvider } from 'src/contexts/AuthContext';
import { SettingsProvider } from 'src/contexts/SettingsContext';
import 'src/mixins/chartjs';
import * as serviceWorker from 'src/serviceWorker';
import ScrollReset from './components/ScrollReset';
import { AreYouSureProvider } from './contexts/AreYouSureContext';
import { FiltersProvider } from './contexts/FiltersContext';

enableES5();

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <AuthProvider>
    <FiltersProvider>
      <SettingsProvider>
        <AreYouSureProvider>
          <BrowserRouter
            future={{
              v7_startTransition: true,
              v7_relativeSplatPath: true,
            }}
          >
            <ScrollReset />
            <App />
          </BrowserRouter>
        </AreYouSureProvider>
      </SettingsProvider>
    </FiltersProvider>
  </AuthProvider>,
);

serviceWorker.register();
